var exports = {
  "kL": "x61f99309--ec615a--container",
  "Qq": "x61f99309--ec615a--text",
  "oY": "x61f99309--ec615a--input-row",
  "aY": "x61f99309--ec615a--code",
  "L5": "x61f99309--ec615a--retry",
  "ML": "x61f99309--ec615a--retry-link",
  "qr": "x61f99309--ec615a--footer",
};

module.exports = exports;
